module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: {
      active: _vm.isActive
    },
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.go
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02b06abb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VLink.vue
// module id = 28
// module chunks = 0